export const ListQueryKey = 'projectProjectOrders';
export const DetailQueryKey = 'projectProjectOrder';
export const Urls = {
  selectUrl: '/projectorder/list',
  updateUrl: '/projectorder/update',
  cancelUrl: '/projectorder/cancel',
  deleteUrl: '/projectorder/delete',
  createUrl: '/projectorder/create',
  detailUrl: '/projectorder/info'
};